<template>
  <b-row>
    <template v-if="openedInModal">
      <b-col>
        <EXCMDeviceBrandForm
                :openedInModal="openedInModal"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations" />
      </b-col>
    </template>
    <template v-else>
      <b-col v-if="isLoading">
        <Loader size="lg"></Loader>
      </b-col>
      <b-col v-else>
        <b-row>
          <b-col>
            <router-link :to="{ name: 'EXCMDeviceBrandList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card>
              <EXCMDeviceBrandForm
                      :handle-submit="onSendForm"
                      :handle-update-field="updateField"
                      :values="item"
                      :errors="violations" />
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </template>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMDeviceBrandForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('excmdevicebrand/create')

export default {
  components: {
    EXCMDeviceBrandForm,
    Loader
  },

  props: {
    openedInModal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceBrandCreate')
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      if (this.openedInModal) {
        this.$store.state.modals.excmdevicebrand.form.close = 1
      } else {
        // this.$router.push({ name: 'EXCMDeviceBrandUpdate', params: { id: created['@id'] } })
        this.$router.push({ name: 'EXCMDeviceBrandList' })
      }
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
